import { createIconComponent } from '../../factory/create-icon-component';
export const CheckIcon = createIconComponent(
  'CheckIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.99997 12.9999L8.99997 17.9999L15 11.4545L17.25 8.99994L20 5.99994"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
